var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadMapFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1343_7225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.95 11.95C17.7971 11.1036 18.4128 10.054 18.7381 8.90152C19.0634 7.74908 19.0875 6.53242 18.808 5.36801L21.303 4.29801C21.3791 4.26539 21.4621 4.25218 21.5445 4.25955C21.627 4.26692 21.7063 4.29465 21.7754 4.34025C21.8445 4.38585 21.9012 4.44789 21.9404 4.5208C21.9796 4.59372 22.0001 4.67522 22 4.75801V19L15 22L9 19L2.697 21.701C2.62091 21.7336 2.53792 21.7468 2.45547 21.7395C2.37301 21.7321 2.29368 21.7044 2.22459 21.6588C2.1555 21.6132 2.09881 21.5511 2.05961 21.4782C2.02041 21.4053 1.99993 21.3238 2 21.241V7.00001L5.129 5.65901C4.90884 6.78459 4.96891 7.94704 5.30391 9.04393C5.6389 10.1408 6.23855 11.1385 7.05 11.949L12 16.9L16.95 11.95ZM15.536 10.536L12 14.07L8.464 10.535C7.76487 9.83569 7.2888 8.94477 7.09598 7.97491C6.90316 7.00504 7.00225 5.99977 7.38073 5.08622C7.75921 4.17266 8.40007 3.39185 9.22229 2.8425C10.0445 2.29315 11.0111 1.99994 12 1.99994C12.9889 1.99994 13.9555 2.29315 14.7777 2.8425C15.5999 3.39185 16.2408 4.17266 16.6193 5.08622C16.9977 5.99977 17.0968 7.00504 16.904 7.97491C16.7112 8.94477 16.2351 9.83569 15.536 10.535V10.536Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1343_7225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadMapFill);
export default __webpack_public_path__ + "static/media/road-map-fill.5f3e8f53b52a47972b134d2b586b3fc7.svg";
export { ForwardRef as ReactComponent };